import React from "react";
import CustomTable from "../../components/CustomTable";
import { getArtists } from "../../../store/actions/ArtistsActions";
import { getAgeFromDob } from "../../../utils/functions/date";
import { useNavigate } from "react-router-dom";
import { artistValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateArtist from "./AddUpdate";

const Artist = () => {
  const columns = [
    {
      label: "#",
      render: (row) => <span>{row?.artistCode ?? "-"}</span>,
    },
    {
      label: "Name, Age, City",
      render: (row) => (
        <div>
          <div>{`${row?.firstName ?? ""} ${row?.lastName ?? ""}`.trim()}</div>
          <div className="text-muted small">
            {row?.dob ? `${getAgeFromDob(row?.dob)} Yrs` : "-"}
            {row?.city ? ` . ${row?.city?.name}` : ""}
          </div>
        </div>
      ),
    },
    {
      label: "Email & Phone",
      render: (row) => (
        <div>
          <div>{row?.email || "-"}</div>
          <div className="text-muted small">
            {row?.countryCode && row?.mobileNumber
              ? `${row.countryCode} ${row?.mobileNumber}`
              : "-"}
          </div>
        </div>
      ),
    },
    {
      label: "Latest Project & Role",
      render: (row) => row?.projects?.length > 0 ? (
        <div>
          <div className="text-danger">
            {row.projects[row.projects.length - 1]?.conceptTitle ?? "-"}
          </div>
          <div className="text-muted small">
            {row.projects[row.projects.length - 1]?.ArtistProject?.filter((x) => x.project == row.projects[row.projects.length - 1]._id && x.artist == row._id)[0]?.role ?? "-"}
          </div>
        </div>
      ) : (<div>-</div>),
    },
    // {
    //   label: "History",
    //   render: (row) => (
    //     <div>
    //       <div>
    //         Projects{" "}
    //         <span className="badge bg-dark">{row?.projects?.length ?? 0}</span>
    //       </div>
    //       <div>
    //         Showcased{" "}
    //         <span className="badge bg-success">
    //           {row?.projects.filter((p) => p.status == "Showcase").length ?? 0}
    //         </span>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      label: "History",
      render: (row) => (
        <div>
          <div className="d-flex gap-4 align-items-center">
            <span>Projects</span>
            <span className="badge bg-dark">{row?.projects?.length ?? 0}</span>
          </div>
          <div className="d-flex gap-2 align-items-center mt-1">
            <span>Showcased</span>
            <span className="badge bg-success">
              {row?.projects?.filter((p) => p.status === "Showcase").length ??
                0}
            </span>
          </div>
        </div>
      ),
    },
  ];

  const navigate = useNavigate();

  const modalConfig = {
    initialValues: {
      _id: "",
      firstName: "",
      lastName: "",
      dob: "",
      email: "",
      mobileNumber: "",
      gender: "",
      state: "",
      city: "",
      instagramProfile: "",
      profile_image: "",
      description: "",
      hearAbout: "admin",
      referenceLinks: [],
      portfolioPdf: "",
    },
    validationSchema: artistValidationSchema,
    apiUrl: "artist/",
    FormComponent: (props) => <AddUpdateArtist {...props} showrole={false} />,
    addTitle: "Add Artis",
    updateTitle: "Update Artist",
    extraProps: { relationKeys: ["city", "state"] }

  };

  return (
    <CustomTable
      columns={columns}
      title="Artists"
      getHook={getArtists}
      store={"artists"}
      deleteHook={"artist"}
      addBtnTitle={false}
      filterIcon={false}
      search={true}
      isEdit={true}
      formModal={true}
      modalConfig={modalConfig}
      isDelete={true}
      onRowClick={(id, data) => {
        navigate(`/artists/${id}`);
      }}
    //   showStats={true}
    />
  );
};

export default Artist;
